import React from "react";
import UiUxSvg from "../assets/images/svg/ui-ux.svg";
import DownArrow from "../assets/images/svg/down-arrow.svg";
import VisualBranding from "../assets/images/svg/visual-branding.svg";
import WebDevelopement from "../assets/images/svg/web-development.svg";
import AppDevelopement from "../assets/images/svg/app-development.svg";
import GalleryImg2 from "../assets/images/gallery/gallery-img2.jpg";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <>
      {/* <!-- ====================================== Section Services ===================================== --> */}
      <section className="Services-section" id="services">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Services.
          </h2>
          <div className="line"></div>
        </div>
        <h3 className="services-product-text fade_up">
          BUILDING RELIABLE WEB APPS & BACKEND SYSTEMS
        </h3>
        <p className="visoion-text fade_up">
          Focused on high-traffic systems, clean architecture, and practical
          automation—delivering secure APIs, scalable integrations, and
          repeatable deployments.
        </p>
        <div className="row services-row">
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <Link to="#services-popup">
              <div className="services-img">
                <img src={UiUxSvg} alt="ui-ux" />
              </div>
              <p className="services-text">SYSTEM ARCHITECTURE</p>
              <p className="molestie">
                Architecture for WMS/TMS and high-volume traffic systems with
                performance, uptime, and maintainability in mind.
              </p>
              <img
                className="down-arrow-svg"
                src={DownArrow}
                alt="down-arrow"
              />
            </Link>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <Link to="#services-popup">
              <div className="services-img services-img2">
                <img src={VisualBranding} alt="visual-branding" />
              </div>
              <p className="services-text services-text2">BACKEND APIs</p>
              <p className="molestie">
                Secure RESTful APIs and middleware services built with Laravel
                and Node.js (Express.js).
              </p>
              <img
                className="down-arrow-svg"
                src={DownArrow}
                alt="down-arrow"
              />
            </Link>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <Link to="#services-popup">
              <div className="services-img services-img3">
                <img src={WebDevelopement} alt="web-development" />
              </div>
              <p className="services-text services-text3">INTEGRATIONS</p>
              <p className="molestie">
                Webhook processing, third‑party integrations, and data flow
                pipelines handling thousands of daily transactions.
              </p>
              <img
                className="down-arrow-svg"
                src={DownArrow}
                alt="down-arrow"
              />
            </Link>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <Link to="#services-popup">
              <div className="services-img services-img4">
                <img src={AppDevelopement} alt="app-development" />
              </div>
              <p className="services-text services-text4">DEVOPS & CI/CD</p>
              <p className="molestie">
                Automated delivery with GitHub Actions, Linux VPS deployments,
                Docker/Nginx, and safe release practices.
              </p>
              <img
                className="down-arrow-svg"
                src={DownArrow}
                alt="down-arrow"
              />
            </Link>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Services End ===================================== --> */}
      {/* <!-- ====================================== Section Services Pop Up ===================================== --> */}
      <div id="services-popup" className="popup-container">
        <div className="popup-content popup-content2">
          <Link to="#" className="close">
            &times;
          </Link>
          <h2 className="simple-steps">Backend & Systems Engineering</h2>
          <img
            className="blog-popup-img1"
            src={GalleryImg2}
            alt="gallery-img8"
          />
          <p className="blog-sit-text">
            Building production systems means balancing correctness,
            performance, and operational simplicity. The goal is software that
            scales with the business and stays easy to ship.
          </p>
          <p className="blog-sit-text">
            Typical focus areas include API design, middleware layering,
            integration reliability (webhooks), and automated CI/CD pipelines.
          </p>
          <p className="blog-sit-text">
            Tech stack highlights: Laravel, Node.js (Express), Vue.js, MySQL /
            PostgreSQL, Redis, Docker, Nginx, and GitHub Actions.
          </p>
          <h2 className="simple-steps services-popup-text">What I Deliver</h2>
          <p className="blog-sit-text">
            Reliable integrations, scalable backend services, and clean
            developer workflows that reduce production bugs and improve delivery
            speed.
          </p>
          <p className="blog-sit-text">
            If a feature touches production behavior, prefer implementing it in
            React components rather than relying on legacy jQuery scripts under
            `src/assets/javascript/`.
          </p>
        </div>
      </div>
      {/* <!-- ====================================== Services PopUp End ===================================== --> */}
    </>
  );
};
export default Services;
